module.exports = __webpack_public_path__ + "static/media/feature-slideg5.13e17391.jpg";